import { FormattedMessage } from 'react-intl';
import { PaloNextThemeProvider } from '@synergy/theme-palo';
import {
    PoolButton,
    PoolModal,
    PoolModalActions,
    PoolModalContent,
    PoolModalTitle,
    PoolTextfield,
} from '@synergy/components-next';
import { useParams } from 'react-router-dom';
import { useState } from 'react';

import { bonusSettlementsSupplierDetailSelector } from '../store/bonus-settlements-supplier-detail-selector';
import { updateInternalNote } from '../store/bonus-settlements-supplier-detail-actions';
import { useAppSelector } from '../../../../store/use-appstate-selector';
import { useThunkDispatch } from '../../../../store/use-thunk-dispatch';

interface BonusSettlementSupplierDetailInternalCommentModalProps {
    open: boolean;
    onClose: () => void;
}

export const BonusSettlementSupplierDetailInternalCommentModal = (
    props: BonusSettlementSupplierDetailInternalCommentModalProps
) => {
    const { open, onClose } = props;
    const dispatch = useThunkDispatch();
    const bonusSettlementSupplierDetail = useAppSelector(bonusSettlementsSupplierDetailSelector);
    const { bonusSettlementId, id: supplierBonusSettlementId } = useParams<{ bonusSettlementId: string; id: string }>();
    const [comment, setComment] = useState<string>(bonusSettlementSupplierDetail?.internalNote ?? '');

    const handleSave = () => {
        if (bonusSettlementId && supplierBonusSettlementId) {
            dispatch(
                updateInternalNote({
                    bonusSettlementId: +bonusSettlementId,
                    supplierBonusSettlementId: +supplierBonusSettlementId,
                    internalNote: comment,
                })
            );
            onClose();
        }
    };

    const handleClose = () => {
        setComment(bonusSettlementSupplierDetail?.internalNote ?? '');
        onClose();
    };

    return (
        <PaloNextThemeProvider>
            <PoolModal open={open} onClose={handleClose}>
                <PoolModalTitle>
                    <FormattedMessage id="app.bonusSettlements.supplierDetail.internalComment" />
                </PoolModalTitle>
                <PoolModalContent>
                    <PoolTextfield
                        value={comment}
                        onChange={e => setComment(e.target.value.slice(0, 400))}
                        label={<FormattedMessage id="app.bonusSettlements.supplierDetail.comment" />}
                        fullWidth={true}
                        multiline={true}
                        rows={3}
                        hint={
                            <FormattedMessage
                                id="app.common.characterLimit"
                                values={{ value: comment.length ?? 0, total: 400 }}
                            />
                        }
                    />
                </PoolModalContent>
                <PoolModalActions>
                    <PoolButton variant="outlined" onClick={handleClose}>
                        <FormattedMessage id="app.common.close" />
                    </PoolButton>
                    <PoolButton onClick={handleSave} disabled={comment.length === 0}>
                        <FormattedMessage id="app.common.save" />
                    </PoolButton>
                </PoolModalActions>
            </PoolModal>
        </PaloNextThemeProvider>
    );
};
